{
  "title": "Bulk Rebalance",
  "detailTitle": "Rebalance run",
  "breadcrumbRun": "Run {{runId}}",
  "table": {
    "newRun": "New rebalance run",
    "createdAt": "Created At",
    "byCreator": "By {{name}}",
    "type": "Rebalance type",
    "organization": "Organization",
    "status": "Status",
    "result": "Result",
    "empty": "No live rebalance runs yet. Start a run when you are ready to rebalance eligible portfolios.",
    "openRunAria": "Open rebalance run from {{when}}, {{type}}"
  },
  "outcome": {
    "rebalanced": "{{count}} rebalanced",
    "failed": "{{count}} failed",
    "skipped": "{{count}} skipped",
    "none": "No portfolios processed",
    "processing": "Processing portfolios…",
    "processingTotal": "0 of {{total}} portfolios processed",
    "processingProgress": "{{processed}} of {{total}} portfolios processed"
  },
  "actionHint": {
    "preview": "Preview only",
    "reviewResults": "Review results",
    "running": "In progress",
    "failed": "Run failed",
    "review": "Review run"
  },
  "runInsights": {
    "title": "Run insights",
    "impact": {
      "taxTitle": "Tax impact",
      "turnoverTitle": "Turnover",
      "taxableSellsLine": "Taxable sells {{value}} across {{count}} portfolio(s)",
      "estRealizedGainsLine": "Est. realized gains {{value}} across {{count}} portfolio(s)",
      "shelteredOnly": "All sell activity was tax-sheltered",
      "turnoverTypical": "Typical turnover {{value}}%",
      "turnoverDetailed": "Typical {{median}}% · some books as high as {{p90}}%",
      "turnoverRunCaption": "Typical turnover {{value}}%",
      "turnoverRunFootnote": "Share of holdings sold and replaced",
      "turnoverRunP90": "Some portfolios were as high as {{value}}%",
      "tradeMixTitle": "Trade activity",
      "tradeMixRaiseCaption": "Sell-heavy · raising cash",
      "tradeMixDeployCaption": "Buy-heavy · deploying cash",
      "tradeMixMixedCaption": "Mixed buys and sells",
      "tradeMixBuySell": "{{buys}} buys · {{sells}} sells",
      "topTaxableSellsTitle": "Taxable sells",
      "topShelteredSellsTitle": "Sheltered sells",
      "topBatchSellsTitle": "Top sells",
      "topBatchBuysTitle": "Top buys",
      "noteLiquidation": "Full liquidation in {{count}} portfolio(s)",
      "noteFx": "FX exposure flagged in {{count}} portfolio(s)",
      "noteSwitch": "Switch opportunities in {{count}} portfolio(s)",
      "noteCovariance": "Simpler allocation used in {{count}} portfolio(s)",
      "noteCashRaise": "Raising cash in {{count}} portfolio(s)",
      "noteCashDeploy": "Deploying cash in {{count}} portfolio(s)",
      "noteCash": "Cash in {{count}} portfolio(s)",
      "noteMultiCurrency": "Multi-currency in {{count}} portfolio(s)",
      "noteDefault": "{{label}} in {{count}} portfolio(s)"
    },
    "reviewNext": {
      "flags": "Flags",
      "badgeFailed": "Failed",
      "badgeTax": "Tax",
      "badgeHighTurnover": "High turnover",
      "badgeLiquidate": "Liquidation",
      "badgeTransfer": "Pending withdrawal",
      "filter": {
        "all": "All",
        "passed": "Passed",
        "failed": "Failed",
        "liquidate": "Liquidation",
        "transfer": "Pending withdrawal",
        "tax": "Tax",
        "highTurnover": "High turnover"
      }
    }
  },
  "audit": {
    "proposedTrades": "{{count}} proposed trades",
    "totalBuys": "{{value}} buys",
    "totalSells": "{{value}} sells",
    "validationFailedUnknown": "Validation failed with no detailed message."
  },
  "validationDiagnostics": {
    "account": "Account",
    "unknownTicker": "Unknown holding",
    "negativePortfolioCash": "{{value}} portfolio cash",
    "negativeAccountCash": "{{account}}: {{value}} cash",
    "accountMarketValue": "{{account}} market value: {{value}}",
    "negativeHoldingQuantity": "{{accountPrefix}}{{ticker}}: {{quantity}} shares ({{value}})",
    "negativeHoldingValue": "{{accountPrefix}}{{ticker}}: {{value}} position",
    "belowMinimumPortfolioMarketValue": "Portfolio market value {{value}} (below $1.00 minimum)"
  },
  "validationErrors": {
    "nonPositiveMarketValue": "Non-viable market value — often caused by negative cash or holdings",
    "negativeQuantity": "Negative position quantity detected",
    "noSubAccounts": "Portfolio has no sub-accounts",
    "weightsSumMismatch": "Target weights do not sum correctly",
    "invalidCurrency": "Invalid currency on a holding",
    "nonPositivePrice": "Non-positive price on a holding",
    "invalidModelPortfolioType": "Unsupported portfolio type for optimization",
    "assetClassTargetsSumMismatch": "Asset class targets do not sum correctly",
    "unknownCode": "Validation issue: {{code}}"
  },
  "filters": {
    "type": "Type",
    "state": "State",
    "allTypes": "All types",
    "allStates": "All states",
    "clear": "Clear filters"
  },
  "runType": {
    "ALL_ELIGIBLE": "All eligible rebalance",
    "DRIFT": "Drift rebalance",
    "TRANSFER": "Cash rebalance"
  },
  "rebalanceMode": {
    "DEPLOY_CASH": "Deploy cash",
    "RAISE_CASH": "Raise cash",
    "FULL_REBALANCE": "Full rebalance"
  },
  "runTypeDescription": {
    "ALL_ELIGIBLE": "Rebalances every portfolio with an active trigger—cash or cash events, liquidation needs, or drift beyond target allocation.",
    "DRIFT": "Rebalances portfolios that have drifted beyond their target allocation.",
    "TRANSFER": "Rebalances portfolios with available cash or a cash trigger—such as new contributions or pending withdrawals."
  },
  "runState": {
    "INITIATED": "Initiated",
    "OPTIMIZING": "Optimizing",
    "VALIDATING": "Validating",
    "PUBLISHING": "Publishing",
    "COMPLETED": "Completed",
    "FAILED": "Failed"
  },
  "scopeType": {
    "GOAL": "Goal",
    "SUB_ACCOUNT": "Sub-account",
    "HOUSEHOLD": "Household"
  },
  "reports": {
    "client": "Client / household",
    "portfolio": "Portfolio",
    "accounts": "Sleeves",
    "status": "Status",
    "trades": "Trades",
    "scopeType": "Scope",
    "goal": "Goal",
    "model": "Model",
    "marketValue": "Market value",
    "driftRequired": "Drift",
    "cashTrigger": "Cash trigger",
    "tradeRequests": "Trade requests",
    "expandedTradeSummary": "{{count}} proposed trades · {{buys}} buys · {{sells}} sells",
    "noAuditDetail": "Trade detail is not available for this portfolio.",
    "statusPassed": "Passed",
    "statusFailed": "Failed",
    "viewChanges": "View changes",
    "openDetailAria": "Open portfolio {{name}}",
    "noImpactFilterMatches": "No portfolios match this filter on the current page.",
    "noFilterMatches": "No portfolios match the current filters.",
    "filterSearchPlaceholder": "Search portfolio",
    "filterModelLabel": "Model",
    "filterAssetLabel": "Security",
    "filterModelAll": "All models",
    "filterModelSelected": "{{label}} ({{count}})",
    "filterModelOption": "{{label}} ({{count}})",
    "filterAssetAll": "Any security",
    "filterAssetSelected": "{{ticker}} ({{count}})",
    "filterAssetOption": "{{ticker}} · {{count}} portfolios",
    "filterClear": "Clear",
    "filterSummary": "{{count}} matching portfolios",
    "filterScopeNotice": "Filters apply to {{loaded}} of {{total}} loaded portfolios.",
    "filterAssetScopeNotice": "{{shown}} shown here · {{total}} portfolios traded this security in the run.",
    "unresolvedPortfolio": "Portfolio unavailable",
    "unresolvedPortfolioHint": "Client name unavailable — account types are listed in the Sleeves column",
    "sleeveCount": "{{count}} sleeves"
  },
  "drawer": {
    "snapshotNotice": "Values reflect the portfolio at run time.",
    "newPosition": "New",
    "exitPosition": "Exit",
    "sellToCashPosition": "Sell",
    "noWeightDiffs": "No holding changes were recorded for this portfolio.",
    "validationFailedTitle": "Could not rebalance this portfolio",
    "validationWarningTitle": "Review before proceeding",
    "unreliableSnapshotTitle": "Holdings data looks unreliable",
    "unreliableSnapshotBody": "This run recorded a market value equal to cash while still selling positions, so the pre-trade holdings can't be shown accurately. Open the portfolio page to review the actual positions.",
    "unresolvedPortfolioNotice": "Portfolio snapshot is unavailable for this row. Validation details below are from the optimizer audit (report {{reportId}}).",
    "reviewPortfolioOpen": "Open portfolio",
    "auditGrid": {
      "proposed": "Proposed",
      "multiCurrencyCashTooltip": "Current cash by currency. Proposed total is in portfolio base currency."
    }
  },
  "insights": {
    "title": "Rebalance insights",
    "summaryTaxableSells": "Taxable sells {{value}}",
    "summaryShelteredSells": "Sheltered sells only",
    "summaryEstRealizedGains": "Est. gains {{value}}",
    "summaryTurnover": "{{value}}% turnover",
    "changesSectionTitle": "What's changing",
    "triggerDrift": "Drift rebalance",
    "triggerLiquidate": "Liquidation",
    "triggerTransfer": "Pending withdrawal",
    "scopedCashPreview": "Per-sleeve cash rebalance",
    "whyRaisingCash": "Raising {{value}} to fund a withdrawal",
    "whyDeployingCash": "Deploying {{value}} contribution",
    "whyDeployedCashOnSleeve": "Deployed {{value}} on one sleeve",
    "newPositionsLabel": "New positions",
    "soldToRaiseCashLabel": "Sold to raise cash",
    "exitedLabel": "Exited",
    "broughtToTarget": "Rebalanced {{count}} holdings back to target",
    "registeredSells": "Registered sells: {{value}}",
    "registeredSellsHint": "No capital gains",
    "taxableSells": "Taxable sells: {{value}}",
    "taxableSellsHint": "May trigger gains",
    "estRealizedGainsHint": "Est. realized gains {{value}}",
    "estRealizedGainsIncompleteLine": "Could not estimate realized gains for {{count}} taxable sell(s)",
    "estRealizedGainsUnavailable": "Could not estimate realized gains",
    "noTaxableSellsHint": "None",
    "registeredSellPct": "{{value}}% of sell activity is tax-sheltered",
    "shelteredVsTaxable": "{{sheltered}} sheltered · {{taxable}} taxable",
    "turnoverSectionTitle": "Turnover",
    "turnoverMeterHeadline": "{{value}}% of holdings sold and replaced",
    "turnoverBuySell": "Buy {{buyPct}}% · Sell {{sellPct}}%",
    "turnoverHoldingCount": "Across {{count}} holdings",
    "situationsSectionTitle": "Additional considerations",
    "decisionsSectionTitle": "Other adjustments",
    "liquidationSummary": "{{account}} fully liquidated — {{reason}}",
    "liquidationWithdraw": "Pending withdraw-all transfer",
    "liquidationCashTarget": "Cash target exceeds account value",
    "taxLocationApplied": "Tax-location applied across {{subAccountCount}} sleeves and {{holdingCount}} holdings",
    "taxLocationFlow": "Net ~{{value}} shifted from {{from}} to {{to}}",
    "taxLocationSkipped": "Tax-location not applied: {{reason}}",
    "cashRaiseApplied": "Raised {{amount}} from {{count}} holding(s)",
    "cashRaiseAppliedFrom": "Raised {{amount}} from {{holding}} in {{account}}",
    "cashRaiseBlockedMultiCurrency": "Couldn't raise cash — this is a multi-currency account",
    "cashDeployApplied": "Deployed {{amount}} across {{count}} holding(s)",
    "cashDeployAppliedFrom": "Deployed {{amount}} to {{holding}} in {{account}}",
    "cashDeployBlockedMultiCurrency": "Couldn't deploy cash — this is a multi-currency account",
    "multiCurrencyAccount": "This is a multi-currency account",
    "multiCurrencyCashStays": "Cash only buys holdings in the same currency",
    "multiCurrencyCouldNotSeparate": "Couldn't keep currencies separate — trades may mix currencies",
    "multiCurrencyMixedFunding": "A currency was funded with another currency's cash",
    "multiCurrencyNeedsConversion": "Currency mix is off-model — needs a deposit, withdrawal, or conversion",
    "decisionStage": {
      "cashRaise": "Cash raise",
      "cashDeploy": "Cash deploy",
      "cash": "Cash",
      "multiCurrency": "Multi-currency"
    },
    "taxLocationDegenerate": "Tax-location not needed — all holdings share the same tax rank",
    "fxExposure": "FX exposure on {{holdingCount}} holding(s) in {{currencies}} (~{{bps}} bps estimated cost)",
    "switchOpportunitiesPrefix": "Switch opportunities:",
    "covarianceFallback": "Risk-aware optimization was unavailable; used a simpler allocation model",
    "qpFailed": "Optimization failed: {{reason}}",
    "ai": {
      "generate": "Generate insights",
      "generateShort": "Generate notes",
      "regenerate": "Regenerate",
      "betaLabel": "BETA",
      "loading": "Writing summary…",
      "error": "Could not generate insights. Try again.",
      "disclaimerTitle": "About AI insights",
      "disclaimer": "This is a draft generated from the numbers already on this page. It is not advice. Check tickers, amounts, and tax notes against the structured insights.",
      "portfolio": {
        "title": "Advisor notes"
      },
      "run": {
        "title": "Advisor notes"
      },
      "subtitle": "Interpretive summary — structured metrics above are authoritative."
    },
    "failureReasonPortfolioCount_one": "{{label}} · 1 portfolio",
    "failureReasonPortfolioCount_other": "{{label}} · {{count}} portfolios",
    "aiHighlightFailedValidation": "Failed validation",
    "aiHighlightTaxableSells": "Taxable sells",
    "aiHighlightHighTurnover": "High turnover",
    "aiHighlightTypicalPct": "typical {{value}}%",
    "aiHighlightHighestPct": "highest {{value}}%"
  },
  "accountTypeChip": {
    "PERSONAL": "Non-Reg",
    "CORPORATE": "Corp"
  },
  "detail": {
    "startedAt": "Started {{value}}",
    "updatedAt": "Updated {{value}}",
    "outcomeLabel": "Outcome: {{value}}",
    "progressLabel": "Run progress",
    "progressStateDescription": {
      "INITIATED": "Starting rebalance run…",
      "OPTIMIZING": "Calculating target allocations and proposed trades.",
      "VALIDATING": "Checking portfolio data and optimization results.",
      "PUBLISHING": "Publishing rebalanced portfolio reports."
    },
    "progressProcessedCount": "{{processed}} of {{total}} portfolios processed",
    "progressPreviewCount": "{{count}} portfolio(s) ready to preview",
    "progressPollingNotice": "Results will appear below as each portfolio completes.",
    "reportsTitle": "Rebalanced portfolios",
    "noReports": "No rebalanced portfolio reports were published for this run.",
    "noDryRunReports": "No rebalanced portfolios were found for this dry run.",
    "inProgressNotice": "This run is still processing. Reports will appear when it completes.",
    "failedNotice": "This run failed before publishing rebalanced portfolio reports.",
    "dryRunCompleteNotice": "Dry runs are for preview only. Start a live run when you are ready to send trades.",
    "zeroSucceededNotice": "No portfolios were rebalanced in this run. Review eligibility or try again after addressing skips and failures.",
    "proceedToBulkTrader": "Proceed to bulk trader",
    "proceedDryRunBlocked": "Bulk trades can only be generated from a completed live run.",
    "proceedZeroSucceededBlocked": "There are no rebalanced portfolios to send to the bulk trader.",
    "proceedMissingPermission": "You need write:bulk_trade_run permission to proceed to the bulk trader."
  },
  "reviewTrades": {
    "title": "Review trades",
    "openStep": "Review trades",
    "backToResults": "Back to run results",
    "subtitle": "{{count}} trade request(s) from this run",
    "empty": "No trade requests were created for this run.",
    "truncated": "Showing the first {{shown}} of {{total}} trade requests.",
    "readyCount": "{{count}} Ready",
    "heldCount": "{{count}} Held",
    "pendingCount": "{{count}} Pending",
    "canceledCount": "{{count}} Canceled",
    "unverifiedCount": "{{count}} need approval",
    "unverifiedNotice": "Approve remaining trade requests before proceeding.",
    "evaluating": "Applying trade schedules…",
    "unknownPortfolio": "Unknown portfolio",
    "sharesAll": "All",
    "groupTradeCount_one": "{{count}} trade",
    "groupTradeCount_other": "{{count}} trades",
    "groupBuy": "buy {{amount}}",
    "groupSell": "sell {{amount}}",
    "evaluateError": "Could not apply trade schedules.",
    "cancelError": "Could not cancel trade requests.",
    "approveError": "Could not approve trade requests.",
    "cancelSuccess": "Canceled {{count}} trade request(s).",
    "approveSuccess": "Approved {{count}} trade request(s).",
    "proceedNoTrades": "There are no active trade requests to send to the bulk trader.",
    "proceedNeedsApproval": "Approve remaining trade requests before proceeding to the bulk trader.",
    "proceedWaiting": "Trade requests are still arriving for this run.",
    "proceedEvaluating": "Trade schedules are still being applied.",
    "proceedMissingEvaluatePermission": "You need write:sub_trade_request permission to apply trade schedules.",
    "toggleGroupAria": "Toggle trades for {{name}}",
    "selectAllAria": "Select all actionable trades",
    "selectTradeAria": "Select {{ticker}} trade",
    "settlementBadge": "T+{{days}}",
    "approveSelected": "Approve selected",
    "cancelSelected": "Cancel selected",
    "cancelAll": "Cancel all",
    "cancelRow": "Cancel",
    "cancelAllTitle": "Cancel all trade requests?",
    "cancelAllBody": "This permanently cancels every pending trade from this run. They cannot be regenerated from this page.",
    "cancelAllFilteredTitle": "Cancel matching trade requests?",
    "cancelAllFilteredBody": "This permanently cancels {{count}} pending trade request(s) matching your current filters. Hidden trades are not canceled. They cannot be regenerated from this page.",
    "cancelAllConfirm": "Cancel all trades",
    "cancelSelectedTitle": "Cancel selected trade requests?",
    "cancelSelectedBody": "This permanently cancels {{count}} trade request(s). They cannot be regenerated from this page.",
    "cancelRowTitle": "Cancel this trade request?",
    "cancelRowBody": "This permanently cancels {{ticker}}. It cannot be regenerated from this page.",
    "cancelRowFallback": "this trade request",
    "cancelRowConfirm": "Cancel trade",
    "cancelConfirm": "Cancel trades",
    "keepTrades": "Keep trades",
    "columns": {
      "portfolio": "Portfolio",
      "security": "Portfolio / security",
      "type": "Type",
      "amount": "Amount",
      "price": "Price",
      "shares": "Shares",
      "sleeves": "Sleeves",
      "account": "Account",
      "status": "Status",
      "note": "Note"
    },
    "status": {
      "READY": "Ready",
      "HELD": "Held",
      "INITIATED": "Pending",
      "CANCELED": "Canceled",
      "REQUESTED": "Requested",
      "RECONCILED": "Reconciled",
      "VERIFIED": "Approved"
    },
    "holdReason": {
      "schedule": "Scheduled {{date}}",
      "blockedUntil": "Held until {{date}}",
      "accountInactive": "Account not active",
      "subAccountInactive": "Sub-account not active"
    },
    "note": {
      "awaitingProceeds": "Waiting for sell proceeds",
      "awaitingProceedsTooltip": "This buy needs cash from a sale that settles later.",
      "awaitingProceedsWithTickerTooltip": "Needs cash from {{ticker}}, which settles later than this buy.",
      "pendingWithdraw": "Cash reserved for a withdrawal",
      "pendingWithdrawTooltip": "Available cash is held for a pending withdrawal, so this buy is waiting to avoid extra trading."
    },
    "type": {
      "BUY": "Buy",
      "SELL": "Sell"
    },
    "filterSearchPlaceholder": "Search client, portfolio, or ticker",
    "filterClear": "Clear filters",
    "filterNoMatches": "No trades match the current filters.",
    "filterResults": "Showing {{portfolioCount}} portfolios · {{tradeCount}} trades",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "filterStatus": {
      "all": "All",
      "ready": "Ready",
      "held": "Held",
      "pending": "Pending",
      "canceled": "Canceled",
      "needsApproval": "Needs approval"
    }
  },
  "startRun": {
    "title": "Start rebalance run",
    "typeLabel": "Rebalance focus",
    "cancel": "Cancel",
    "confirm": "Start run",
    "driftToleranceNote": "Includes portfolios the drift engine has already flagged against each portfolio's own tolerance.",
    "changeDriftTolerance": "Change in trade settings"
  }
}
